import dayjs from 'dayjs';
import DayjsDuration from 'dayjs/plugin/duration';
import DayjsUtc from 'dayjs/plugin/utc';
import { base64ToStr } from '@/std/base64';
import { DATE_TIME_FORMAT } from '@/std/const/date';

dayjs.extend(DayjsUtc);
dayjs.extend(DayjsDuration);

export type TokenResponse =
    | {
          valid: true;
          token: string;
      }
    | {
          valid: false;
          token: null;
      };

// A quantidade de horas que leva pro token expirar
const TOKEN_EXPIRE_HOURS = 12;

export function isJwtValid(jwt: string): boolean {
    if (typeof jwt !== 'string') {
        return false;
    }

    try {
        const parts = jwt.split('.');

        if (parts.length !== 3) {
            return false;
        }

        const part = parts[1];

        if (!part) {
            return false;
        }

        const decoded = base64ToStr(part);
        JSON.parse(decoded);
    } catch {
        return false;
    }

    return true;
}

export function validateToken(
    token: string | undefined,
    tokenExp: string | undefined,
): TokenResponse {
    const isValidDate = dayjs(tokenExp, DATE_TIME_FORMAT, true).isValid();

    if (!token || !isValidDate || !isJwtValid(token)) {
        return { token: null, valid: false };
    }

    const startUtc = dayjs.utc(tokenExp, DATE_TIME_FORMAT, true);
    const hours = dayjs.utc().diff(startUtc, 'hour', true);

    if (hours > TOKEN_EXPIRE_HOURS) {
        return { token: null, valid: false };
    }

    return { token, valid: true };
}
